import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// English resources
import enCommon from "../locales/en/common.json";
import enLayout from "../locales/en/layout.json";
import enAuth from "../locales/en/auth.json";
import enDashboard from "../locales/en/dashboard.json";
import enEvents from "../locales/en/events.json";
import enEventDetails from "../locales/en/eventDetails.json";
import enDisputes from "../locales/en/disputes.json";
import enWallet from "../locales/en/wallet.json";
import enSettings from "../locales/en/settings.json";
import enRooms from "../locales/en/rooms.json";
import enRoomAccess from "../locales/en/roomAccess.json";
import enGallery from "../locales/en/gallery.json";
import enUploads from "../locales/en/uploads.json";
import enAutoUpload from "../locales/en/autoUpload.json";
import enLinkedDevices from "../locales/en/linkedDevices.json";
import enLocations from "../locales/en/locations.json";
import enAccessRequests from "../locales/en/accessRequests.json";
import enHistory from "../locales/en/history.json";
import enCompanion from "../locales/en/companion.json";
import enAi from "../locales/en/ai.json";
import enNotifications from "../locales/en/notifications.json";
import enChat from "../locales/en/chat.json";
import enTeam from "../locales/en/team.json";
import enAnalytics from "../locales/en/analytics.json";
import enSubAccounts from "../locales/en/subAccounts.json";

// German resources
import deCommon from "../locales/de/common.json";
import deLayout from "../locales/de/layout.json";
import deAuth from "../locales/de/auth.json";
import deDashboard from "../locales/de/dashboard.json";
import deEvents from "../locales/de/events.json";
import deEventDetails from "../locales/de/eventDetails.json";
import deDisputes from "../locales/de/disputes.json";
import deWallet from "../locales/de/wallet.json";
import deSettings from "../locales/de/settings.json";
import deRooms from "../locales/de/rooms.json";
import deRoomAccess from "../locales/de/roomAccess.json";
import deGallery from "../locales/de/gallery.json";
import deUploads from "../locales/de/uploads.json";
import deAutoUpload from "../locales/de/autoUpload.json";
import deLinkedDevices from "../locales/de/linkedDevices.json";
import deLocations from "../locales/de/locations.json";
import deAccessRequests from "../locales/de/accessRequests.json";
import deHistory from "../locales/de/history.json";
import deCompanion from "../locales/de/companion.json";
import deAi from "../locales/de/ai.json";
import deNotifications from "../locales/de/notifications.json";
import deChat from "../locales/de/chat.json";
import deTeam from "../locales/de/team.json";
import deAnalytics from "../locales/de/analytics.json";
import deSubAccounts from "../locales/de/subAccounts.json";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", short: "EN" },
  { code: "de", label: "Deutsch", short: "DE" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: enCommon,
        layout: enLayout,
        auth: enAuth,
        dashboard: enDashboard,
        events: enEvents,
        eventDetails: enEventDetails,
        disputes: enDisputes,
        wallet: enWallet,
        settings: enSettings,
        rooms: enRooms,
        roomAccess: enRoomAccess,
        gallery: enGallery,
        uploads: enUploads,
        autoUpload: enAutoUpload,
        linkedDevices: enLinkedDevices,
        locations: enLocations,
        accessRequests: enAccessRequests,
        history: enHistory,
        companion: enCompanion,
        ai: enAi,
        notifications: enNotifications,
        chat: enChat,
        team: enTeam,
        analytics: enAnalytics,
        subAccounts: enSubAccounts,
      },
      de: {
        common: deCommon,
        layout: deLayout,
        auth: deAuth,
        dashboard: deDashboard,
        events: deEvents,
        eventDetails: deEventDetails,
        disputes: deDisputes,
        wallet: deWallet,
        settings: deSettings,
        rooms: deRooms,
        roomAccess: deRoomAccess,
        gallery: deGallery,
        uploads: deUploads,
        autoUpload: deAutoUpload,
        linkedDevices: deLinkedDevices,
        locations: deLocations,
        accessRequests: deAccessRequests,
        history: deHistory,
        companion: deCompanion,
        ai: deAi,
        notifications: deNotifications,
        chat: deChat,
        team: deTeam,
        analytics: deAnalytics,
        subAccounts: deSubAccounts,
      },
    },
    ns: [
      "common", "layout", "auth", "dashboard", "events", "eventDetails",
      "disputes", "wallet", "settings", "rooms", "gallery", "uploads",
      "autoUpload", "linkedDevices", "locations", "accessRequests",
      "history", "companion", "ai", "notifications", "chat", "team", "analytics",
      "subAccounts",
    ],
    defaultNS: "common",
    fallbackLng: "en",
    supportedLngs: ["en", "de"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "psPromoterLang",
    },
    react: { useSuspense: false },
  });

export default i18n;
